
const initialState = {
  mainServices: {},
  loading: false
};

export function fetchMainServices(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_MAIN_SERVICES.SUCCESS':
      return {
        ...state,
        mainServices:  action.mainServices.body
      };
    default:
      return state
  }
}

export function saveMainServices(state = initialState, action) {
  switch (action.type) {
    default:
      return state
  }
}
